
























































import {
  Component,
  Emit,
  Prop,
  PropSync,
  Vue,
  Watch
} from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import ServerError from '@/utils/server_error'
import userStore from '@/modules/auth/auth.store'
import tournamentStore from '@/modules/tournament/tournament.store'
import ConfirmDialog from '@/modules/shared/components/ConfirmDialog'
import {
  ResponseStatus,
  TournamentAPI,
  TournamentEntity
} from '@/api/tournament'
import {
  TournamentTeamEntity,
  TournamentPlayerEntity,
  TournamentTeamRole
} from '@/api/tournamentTeam'
import i18n from '@/lang'

@Component({
  components: {
    ConfirmDialog
  }
})
export default class EditTournamentTeamMemberGameAccountDialog extends Vue {
  userModule = getModule(userStore, this.$store)
  tournamentModule = getModule(tournamentStore, this.$store)

  @PropSync('visible', { default: false }) isVisible!: boolean

  newCaptainMemberId: string = ''
  newGameAccountName: string = ''
  isConfirmDialogVisible: boolean = false
  isChangingName: boolean = false

  inGameNameRules: Function[] = [
    (v: any) => !!v || i18n.t('InGameNameRegistration.InGameNameIsRequired')
  ]

  /* Watchers */
  @Watch('isVisible')
  onVisibleChange(visible: boolean) {
    if (!visible) {
      this.newCaptainMemberId = ''
      this.newGameAccountName = ''
    } else {
      if (this.me) {
        this.newGameAccountName = this.me.gameAccountNickname
      }
    }
  }

  /* Methods */
  async changeName() {
    this.isChangingName = true
    try {
      const response = await TournamentAPI.changeTournamentTeamGameAccount(
        this.selectedTournamentTeam!.tournamentTeamId,
        this.newGameAccountName
      )
      if (response.data.status === ResponseStatus.Ok) {
        this.$toast.success(
          this.$t(
            'EditTournamentTeamMemberGameAccountDialog.GameAccountNameChanged'
          )
        )
        this.nameChanged()
      }
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('Loading.SystemErrorMessage'))
      }

      console.error(err)
    } finally {
      this.isChangingName = false
      this.isConfirmDialogVisible = false
      this.isVisible = false
    }
  }

  nameChanged() {
    this.newCaptainMemberId = ''
    this.newGameAccountName = ''
    this.$emit('changed')
  }

  /* Computed Properties */
  get selectedTournamentTeam(): TournamentTeamEntity | null {
    return this.tournamentModule.selectedTournamentTeam
  }

  get selectedTournament(): TournamentEntity | null {
    return this.tournamentModule.selectedTournament
  }

  get wildRiftHint() {
    if (!this.selectedTournament || this.selectedTournament.game !== 'WildRift')
      return ''

    return '此遊戲的 RIOT ID 遊戲帳號格式為： ABCDEF#1234'
  }

  get game() {
    if (!this.selectedTournament) return ''

    return this.selectedTournament.game
  }

  get userId() {
    return this.userModule.userId
  }

  get players(): TournamentPlayerEntity[] {
    if (!this.selectedTournamentTeam) return []
    return this.selectedTournamentTeam.players.filter(
      player => player.role !== TournamentTeamRole.RequestToJoin
    )
  }

  get me() {
    if (!this.selectedTournamentTeam) return null

    return this.selectedTournamentTeam.players.find(
      player => player.memberId === this.userId
    )
  }

  get confirmDialogMessage() {
    return this.$t(
      'EditTournamentTeamMemberGameAccountDialog.ConfirmDialogMessage',
      {
        captainName: this.newGameAccountName
      }
    )
  }
}
